import * as Yup from 'yup'
import { WebhookSubscriber } from '../../../interfaces/Webhook'

export const WebhookSubscriberSchema = Yup.object().shape({
  webHookUrl: Yup.string().url('URL invalida').required('Requerido'),
  secret: Yup.string()
    .nullable()
    .test(
      'no-only-whitespace', // Nombre de la prueba
      'No puede ser solo espacios en blanco', // Mensaje de error
      (value) => !value || value.trim().length > 0 // Condición (permite cadenas vacías o valores que no sean solo espacios)
    ),
  active: Yup.bool(),
  headers: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().trim().required('Requerido'),
      value: Yup.string().trim().required('Requerido')
    })
  )
})

export const initialFormValues: WebhookSubscriber = {
  webhookSubscriberId: 0,
  webHookUrl: '',
  active: true,
  events: [],
  headers: [],
  secret: '',
  subscribedEvents: []
}

export const availableWebhookEvents = [
  { webHookEventId: 1, name: 'Notificaciones Orden de Trabajo' },
  { webHookEventId: 2, name: 'Notificaciones Pedido' },
  { webHookEventId: 3, name: 'Notificaciones ASN' }
]
